import { api } from './http';
import type { CaseType, PracticeArea } from './types';

interface PracticeAreaCreatePayload {
  name: string;
  description?: string | null;
  case_type?: CaseType | null;
}

interface PracticeAreaUpdatePayload {
  name?: string;
  description?: string | null;
  case_type?: CaseType | null;
}

export const getPracticeAreas = () =>
  api.get<PracticeArea[]>('/practice-areas').then(r => r.data);

export const createPracticeArea = (data: PracticeAreaCreatePayload) =>
  api.post<PracticeArea>('/practice-areas', data).then(r => r.data);

export const updatePracticeArea = (id: number, data: PracticeAreaUpdatePayload) =>
  api.patch<PracticeArea>(`/practice-areas/${id}`, data).then(r => r.data);

export const deletePracticeArea = (id: number) =>
  api.delete(`/practice-areas/${id}`).then(r => r.data);
